import { ReactElement } from 'react';
import { Box } from '@mui/material';

export default function PageLoader(): ReactElement {
  return <Box className="preloader" sx={{ display: 'flex' }} />;
}
